import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NeedType } from '../../types/needs';

export interface NeedsState {
  [NeedType.HUNGER]: number;
  [NeedType.THIRST]: number;
  [NeedType.FATIGUE]: number;
  [NeedType.MORALE]: number;
}

const initialState: NeedsState = {
  [NeedType.HUNGER]: 0,
  [NeedType.THIRST]: 0,
  [NeedType.FATIGUE]: 0,
  [NeedType.MORALE]: 0,
};

const needsSlice = createSlice({
  name: 'needs',
  initialState,
  reducers: {
    replenishNeed: (state, action: PayloadAction<{ type: NeedType; amount: number }>) => {
      // Implement replenishNeed logic using action.payload
    },
    saveNeedsState: (state, action: PayloadAction<{ operatorId: string }>) => {
      // Implement saveNeedsState logic
    },
  },
});

export const { replenishNeed, saveNeedsState } = needsSlice.actions;
export default needsSlice.reducer;